export default "__VITE_ASSET__b7HPUe72__"